import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { IExportDefaultDTO } from '@interfaces/common/defaultDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_ALARM_HISTORY } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateExportActiveAlarmsFlexidasReturn {
	handlePreparingExport: UseMutateFunction<any, any, IExportDefaultDTO, any>;
	isLoadingExportAlarmHistoryFile: boolean;
}

export const useMutateExportAlarmFile = (
	queryFn: (dto: IExportDefaultDTO) => Promise<IExportDefaultDTO>,
): IUseMutateExportActiveAlarmsFlexidasReturn => {
	const dispatch = useAppDispatch();

	const {
		mutate: handlePreparingExport,
		isLoading: isLoadingExportAlarmHistoryFile,
	} = useMutation<IExportDefaultDTO>({
		mutationKey: [EXPORT_ALARM_HISTORY],
		mutationFn: queryFn,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handlePreparingExport,
		isLoadingExportAlarmHistoryFile,
	};
};
